import * as React from 'react';
import { QuestionLayout, IQuestionLayoutProps } from '../../components/QuestionLayout';
import { formContextObj } from '../FormContainer/context';
import { PolicyAgreement } from '../../components/PolicyAgreement';
import { useDeviceType } from '@cian/ui-kit';

/**
 * Контейнер для QuestionLayout
 * Прокидывает в футер текст соглашения, только для 1го вопроса и только для десктопа
 * */
export const QuestionLayoutContainer: React.FC<IQuestionLayoutProps> = props => {
  const { footer: propsFooter } = props;
  const { stepsHistory } = React.useContext(formContextObj);
  const stepsHistoryLength = stepsHistory.length;
  const deviceType = useDeviceType();

  const footer = React.useMemo(() => {
    if (deviceType === 'desktop' && stepsHistoryLength === 1) {
      return <PolicyAgreement />;
    }

    return propsFooter;
  }, [deviceType, stepsHistoryLength, propsFooter]);

  return <QuestionLayout {...props} footer={footer} />;
};

QuestionLayoutContainer.displayName = 'QuestionLayoutContainer';
